// Politique de mot de passe (USR-005) — partagée par tous les formulaires
// (inscription, acceptation d'invitation, réinitialisation).
// Doit rester cohérente avec `validate_password_strength()` côté backend
// (backend/server_supabase.py).

export const PASSWORD_MIN_LENGTH = 8;

// Liste ordonnée des règles, chacune avec son test et son libellé affiché
// dans l'indicateur de force en temps réel.
export const PASSWORD_RULES = [
  { key: 'length', label: `Au moins ${PASSWORD_MIN_LENGTH} caractères`, test: (pwd) => pwd.length >= PASSWORD_MIN_LENGTH },
  { key: 'uppercase', label: 'Une majuscule', test: (pwd) => /[A-Z]/.test(pwd) },
  { key: 'lowercase', label: 'Une minuscule', test: (pwd) => /[a-z]/.test(pwd) },
  { key: 'digit', label: 'Un chiffre', test: (pwd) => /\d/.test(pwd) },
  { key: 'special', label: 'Un caractère spécial (ex: !@#$%^&*)', test: (pwd) => /[^A-Za-z0-9]/.test(pwd) },
];

// Retourne le premier message d'erreur en français si le mot de passe ne
// respecte pas la politique, ou null s'il est valide.
export function validatePasswordStrength(password) {
  const pwd = password || '';
  const failed = PASSWORD_RULES.find((rule) => !rule.test(pwd));
  if (!failed) return null;
  return failed.key === 'length'
    ? `Le mot de passe doit contenir au moins ${PASSWORD_MIN_LENGTH} caractères`
    : `Le mot de passe doit contenir au moins ${
        { uppercase: 'une majuscule', lowercase: 'une minuscule', digit: 'un chiffre', special: 'un caractère spécial (ex: !@#$%^&*)' }[failed.key]
      }`;
}

// Retourne l'état (respectée ou non) de chaque règle, pour l'affichage de
// l'indicateur de force en temps réel.
export function getPasswordRuleStatus(password) {
  const pwd = password || '';
  return PASSWORD_RULES.map((rule) => ({ key: rule.key, label: rule.label, ok: rule.test(pwd) }));
}
